import React, {Fragment, useContext} from 'react'
import {AppContext} from '../app/app'

const GameOverStats = () => {
    const {config} = useContext(AppContext)
    const {gameStats} = config

    return (
        <Fragment>
            <h2>{gameStats.victory ? 'You Won!' : 'You Lost'}</h2>

            <div className="row">
                <div className="col col-25">
                    <h2>Score</h2>
                </div>
                <div className="col col-75 text-align-right">
                    <h2>
                        {gameStats.score && gameStats.score.toLocaleString()}
                    </h2>
                </div>
            </div>

            <table>
                <tbody>
                    <tr>
                        <td>Artifacts Collected</td>
                        <td className="text-align-right">
                            {gameStats.artifactsCollected}
                        </td>
                    </tr>
                    <tr>
                        <td>Planets Colonized</td>
                        <td className="text-align-right">
                            {gameStats.planetsColonized}
                        </td>
                    </tr>
                    <tr>
                        <td>Planets Conquered</td>
                        <td className="text-align-right">
                            {gameStats.planetsConquered}
                        </td>
                    </tr>
                    <tr>
                        <td>Planets Lost</td>
                        <td className="text-align-right">
                            {gameStats.planetsLost}
                        </td>
                    </tr>
                    <tr>
                        <td>Ships Built</td>
                        <td className="text-align-right">
                            {gameStats.shipsBuilt}
                        </td>
                    </tr>
                    <tr>
                        <td>Ships Destroyed</td>
                        <td className="text-align-right">
                            {gameStats.shipsDestroyed}
                        </td>
                    </tr>
                    <tr>
                        <td>Ships Lost</td>
                        <td className="text-align-right">
                            {gameStats.shipsLost}
                        </td>
                    </tr>
                </tbody>
            </table>
        </Fragment>
    )
}

export default GameOverStats
